module.exports = __webpack_public_path__ + "img/bim (1).96fd22f4.png";